<app-job-signoff-reschedule-modal [job]='this.job'></app-job-signoff-reschedule-modal>
<app-job-signoff-charges-only [job]='this.job'></app-job-signoff-charges-only>
@if (this.isError) {
  <div class="alert alert-danger">Please complete all required fields</div>
}
@if (this.isSaveDisabled) {
  <div class="alert alert-danger">Save has been disabled. This job has been invoiced.</div>
}
<div [class.fullcontainer]='!this.isPopup'>
  @if (this.isAllWeightsSupplied && this.getUnitName(this.orderLines[0].quoteLine ? this.orderLines[0].quoteLine.product.unitId : this.orderLines[0].unitId).name.toLowerCase() === "tonne" && this.mode !== "transport") {
    <div class='alert alert-danger'>You have not supplied all weights for tickets</div>
  }

  <div class="sheet">
    <h1 class='header'>Job Signoff - ID: {{ this.job.id }}</h1>
    <hr />

    <h2 class='header'>Job Details</h2>
    <br />

    <div class='form-row'>


      <div class="form-group col-md-4" >
        <label>Date</label>
        <input class='form-control' type='text' readonly [value]='this.job.date' />
      </div>

      <div class="form-group col-md-4" >
        <label>Customer</label>
        <input class='form-control' type='text' readonly [value]='this.job.order.account.name' />
      </div>

      <div class="form-group col-md-4" >
        <label>Site</label>
        <input class='form-control' type='text' readonly [value]='this.job.order.site.name' />
      </div>


      @if (this.job.jobAssignment.driverId !== -1) {
        <div class="form-group col-md-4">
          <label>Vehicle</label>
          <input class='form-control' type='text' readonly [value]='this.job.jobAssignment.vehicle.registration' />
        </div>
      }
      @if (this.job.jobAssignment.vehicleId !== -1) {
        <div class="form-group col-md-4">
          <label>Driver</label>
          <input class='form-control' type='text' readonly
            [value]='this.job.jobAssignment.driver.firstName + " " + this.job.jobAssignment.driver.lastName' />
        </div>
      }
      @if (this.job.jobAssignment.vehicleId === -1) {
        <div class="form-group col-md-4">
          <label>Subcontractor</label>
          <input class='form-control' type='text' readonly [value]='this.job.jobAssignment.subcontractor.name' />
        </div>
      }
      @if (this.job.jobAssignment.vehicleId === -1) {
        <div class="form-group col-md-4">
          <label>Subcontractor Reg</label>
          <input class='form-control' type='text' [(ngModel)]='this.job.subcontractorReg' />
        </div>
      }
      <div class="form-group col-md-4">
        <label for="inputEmail4">Grade</label>
        <select class='form-control' [class.is-invalid]='this.job.order.gradeId === -1' (change)='this.job.order.gradeId = +$event.target.value; this.job.order.grade.id = this.job.order.gradeId;'>
          <option value='-1'>Select a grade</option>
          @for (item of this.grades; track item) {
            <option [value]='item.id' [selected]='this.job.order.gradeId === item.id'>{{ item.name }}@if (item.ewcCodes && item.ewcCodes !== "") {
              ({{ item.ewcCodes }})
            }</option>
          }
        </select>
      </div>

      <div class="form-group col-md-4">
        <label for="inputEmail4">PO Number</label>
        <input type="text" name='name' [(ngModel)]='this.job.order.poNumber'
          [class.is-invalid]='!this.job.order.poNumber' class="form-control" id="inputEmail4">
      </div>


      <!-- <div class="form-group col-md-4">
      <label for="inputEmail4">Qty</label>
      <input type="number" name='name' [(ngModel)]='this.job.qty' [class.is-invalid]='!this.job.qty'
        class="form-control" id="inputEmail4">
    </div> -->
    <div class="form-group col-md-4">
      <label for="inputEmail4">Tip Site</label>
      <select class='form-control' [class.is-invalid]='this.job.order.tipSiteId === -1'
        (change)='this.job.order.tipSiteId = +$event.target.value; this.job.order.tipSite = {}; this.job.order.tipSite.id = this.job.order.tipSiteId; this.loadTippingPrice()'>

        <option value='-1'>Select a tip site</option>
        @for (item of this.tips; track item) {
          <option [value]='item.id' [selected]='this.job.order.tipSiteId === item.id'>{{
          item.name }}</option>
        }
      </select>
    </div>

    @if (this.invoiceItem !== null && this.invoiceItem !== undefined) {
      @if (this.invoiceItem?.id !== -1) {
        <div class="form-group col-md-4">
          <label for="inputEmail4">Invoice:</label>
          <!-- <button class='btn btn-primary' type='button' [routerLink]="'/invoices/edit/' + this.invoiceItem.invoiceId"> View Invoice {{ this.invoiceItem.invoiceId}}</button> -->
          <button class='btn btn-primary' type='button' (click)='this.createPDFFile(this.invoiceItem.invoiceId)'> View Invoice {{ this.invoiceItem.invoiceId}}</button>
        </div>
      }
    }

  </div>

  <h2 class='header' style='color:#1367a5 !important'>Material Uplift Charges</h2>
  <table class='table'>
    <thead>
      <th>Account</th>
      <th>Ticket Number</th>
      <th>Name</th>
      <th>Unit</th>
      <th>Qty</th>
      <th>Price</th>
    </thead>
    <tbody>
      @for (uplift of this.upliftTickets; track uplift) {
        <tr>
          <td><ng-select [(ngModel)]="uplift.accountId" (change)='uplift.accountId= +$event; setAccount();'>
            @for (item of this.tips; track item) {
              <ng-option [selected]='uplift.accountId === item.id' [value]='item.id'>{{ item.name }}</ng-option>
            }
          </ng-select></td>
          <td><input class='form-control' type='text' [(ngModel)]="uplift.ticketNumber" /></td>
          <td><input class='form-control' type='text' [(ngModel)]="uplift.name" /></td>
          <td><select class='form-control' (change)='uplift.unitId = +$event.target.value'>
            @for (unit of this.units; track unit) {
              <option [value]='unit.id' [selected]='unit.id === uplift.unitId'>{{ unit.name }}</option>
            }
          </select>
          <td><input class='form-control' type='number' [(ngModel)]="uplift.qty" /></td>
          <td><input class='form-control' type='number' [(ngModel)]="uplift.price" /></td>
        </tr>
      }
    </tbody>
  </table>

  <h2 class='header' style='color:#1367a5 !important'>Charges</h2>

  @if (this.orderLines.length > 0) {
    <table class="table">
      <thead>
        <th>Name</th>
        <th>Qty</th>
        <th>Unit</th>
        <th>Base Price(&pound;)</th>
        <th>Total Price(&pound;)</th>
        <th></th>
        <th></th>
      </thead>
      <tbody>
        @for (item of this.orderLines; track item) {
          <tr>
            <td>{{ item.quoteLine ? item.quoteLine.product.name : item.name }}</td>
            <td>
              @if (this.getUnitName(item.quoteLine ? item.quoteLine.product.unitId : item.unitId).name.toLowerCase() === "tonne") {
                Weights (sep with slash): <input type="text" min='0' name='name' class="form-control" (keyup)='this.setWeight();generateUpliftTicketsFromUplifts()' [(ngModel)]="this.weights">
                Total Weight: <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.qty' [readOnly]='item.isPrimaryCharge'>
              }
              @if (this.getUnitName(item.quoteLine ? item.quoteLine.product.unitId : item.unitId).name.toLowerCase() === "hour") {
                Start Time: <input type='time' class='form-control' [(ngModel)]="this.startTime" (keyup)='this.setHours();this.updateNotesForTimeHire()'>
                End Time: <input type='time' class='form-control' [(ngModel)]="this.endTime" (keyup)='this.setHours();this.updateNotesForTimeHire()'/>
                Break Time (minutes): <input type='number' class='form-control' [(ngModel)]="this.breakTime" (keyup)='this.setHours()'/>
                Waiting Time (minutes): <input type='number' class='form-control' [(ngModel)]="this.waitingTime" (keyup)='this.setHours()'/>
                Travel Time (minutes): <input type='number' class='form-control' [(ngModel)]="this.travelTime" (keyup)='this.setHours();this.updateNotesForTimeHire()'/>
                Chargeable time: <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.qty' [readOnly]='item.isPrimaryCharge'>
              }
              @if (this.getUnitName(item.quoteLine ? item.quoteLine.product.unitId : item.unitId).name.toLowerCase() !== "hour" && this.getUnitName(item.quoteLine ? item.quoteLine.product.unitId : item.unitId).name.toLowerCase() !== "tonne") {
                <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.qty' [readOnly]='item.isPrimaryCharge'>
              }
            </td>
            <td>
              {{ this.getUnitName(item.quoteLine ? item.quoteLine.product.unitId : item.unitId).name}}(s)
            </td>
            <td>
              <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.price'>
            </td>
            <td>
              {{ getTotalPriceForOrderLine(item).toFixed(2) }}
            </td>
            <td>
              <input type='checkbox' [(ngModel)]="item.isPrimaryCharge"
                [ngModelOptions]="{standalone: true}" />&nbsp;
                Is Primary Charge?
                <!-- <input type='checkbox' [(ngModel)]="this.job.overridePrice"
                [ngModelOptions]="{standalone: true}" />&nbsp;
                Override for this job only? -->
            </td>
            <td>
              <button class='btn btn-danger' (click)='deleteOrderLine(item.id)'>Delete Item</button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  <h2 class='header' style='color:#1367a5 !important'>Tip Tickets</h2>
  <table class='table'>
    <thead>
      <th>Collection Ticket Number</th>
      <th>Tipped Ticket Number</th>
      <th>Qty</th>
      <th>Unit</th>
      <th>Cost</th>
      <th>&nbsp;</th>
    </thead>
    <tbody>
      @for (ticket of this.tipTickets; track ticket) {
        <tr>
          <td><input class='form-control' type='text' [(ngModel)]='ticket.collectionTicketNumber' /></td>
          <td><input class='form-control' type='text' [(ngModel)]='ticket.ticketNo' /></td>
          <td><input class='form-control' type='number' [(ngModel)]='ticket.qty' /></td>
          <td>
            <select class='form-control' (change)='ticket.unitId = +$event.target.value'>
              @for (unit of this.units; track unit) {
                <option [selected]='unit.id === ticket.unitId' [value]='unit.id'>{{ unit.name }}</option>
              }
            </select>
          </td>
          <td><input class='form-control' type='number' [(ngModel)]='ticket.price' /></td>
          <td>    <input type='checkbox'
            [(ngModel)]="ticket.isSignedOff"
          [ngModelOptions]="{standalone: true}"/> Signed off </td>
        </tr>
      }
    </tbody>
  </table>

  <h2 class='header' style='color:#1367a5 !important'>PODs</h2>
  <table class='table'>
    <thead>
      <th>POD No</th>
      <th>Qty</th>
      <th>Driver</th>
      <th>Vehicle</th>
      <th>&nbsp;</th>
    </thead>
    <tbody>
      @for (pod of this.pods; track pod) {
        <tr>
          <td>{{ pod.id  }}</td>
          <td>{{ pod.qty }}</td>
          <td>{{ this.job.jobAssignment.driver.firstName + " " + this.job.jobAssignment.driver.lastName }}</td>
          <td>{{ this.job.jobAssignment.vehicle.registration }}</td>
          <td>
            <a class='btn btn-warning' type='button' target='_blank' [href]='"/pods/view/" + pod.id'>Edit</a>&nbsp;
            <a class='btn btn-danger' type='button' target='_blank' [href]='"/pods/delete/" + pod.id'>Delete</a>
          </td>
        </tr>
      }
    </tbody>
  </table>


  <h2 class='header' style='color:#1367a5 !important'>Notes</h2>
  <textarea (keyup)='this.setQtyTotal();generateUpliftTicketsFromUplifts();' class='form-control' [(ngModel)]="this.job.transportSignOffNotes"></textarea><br />

  <h2 class='header'>Signoff Details</h2>
  <br />
  @if (this.mode === "transport") {
    <div class='form-row'>
      <div class="form-group col-md-4">
        <label>Signoff Status</label>
        <select class='form-control' (change)='onStatusChanged($event)'>
          <option value='-1'>Select a status</option>
          <option value='1' [selected]='this.job.jobSignOffStatusId === 1'>Not tipped</option>
          <option value='2' [selected]='this.job.jobSignOffStatusId === 2'>Rescheduled</option>
          <option value='3' [selected]='this.job.jobSignOffStatusId === 3'>Wasted Journey</option>
          <option value='4' [selected]='this.job.jobSignOffStatusId === 4'>Transport sign off</option>
          <option value='5' [selected]='this.job.jobSignOffStatusId === 5'>Contaminated Load</option>
          <option value='6' [selected]='this.job.jobSignOffStatusId === 6'>Rebate</option>
        </select>
      </div>
    </div>
  }

  @if (this.showAdditionalDetails && false) {
    <div class='form-row'>
    </div>
    @if (false) {
      <div class='form-row'>
        <div class='form-group'>
          <label>Manager Signoff?</label>
          <input type='checkbox'
            [(ngModel)]="this.job.jobManagerSignOff"
            [ngModelOptions]="{standalone: true}"/>
        </div>
      </div>
    }
    @if (this.job.jobAssignment.vehicleId !== -1) {
      <div class='form-row'>
        <div class='form-group col-md-4'>
          <label>Gross Weight</label>
          <input type='text' class='form-control' [(ngModel)]='this.job.weight' />
        </div>
      </div>
    }
    <div class='form-row'>
      @if (this.job.jobAssignment.vehicleId !== -1) {
        <div class='form-group col-md-4'>
          <label>Tare Weight</label>
          <input type='text' class='form-control' readonly [value]='this.job.jobAssignment.vehicle.tareWeight' />
        </div>
      }
    </div>
    <div class='form-row'>
      @if (this.job.jobAssignment.vehicleId !== -1) {
        <div class='form-group col-md-4'>
          <label>Net Weight</label>
          <input type='text' class='form-control'
            [value]='(this.job.weight - this.job.jobAssignment.vehicle.tareWeight).toFixed(2)' readonly />
        </div>
      }
    </div>
  }

  <button (click)='deleteAllExistingTickets()' style='display:none;'>Fix tickets</button>
  <button (click)="bulkSaveMaterialUpliftTickets()" style="display:none;">Fix MUL</button>
  @if (!this.isSaveDisabled) {
    <button type="submit" class="btn btn-success" (click)='save()'>Save</button>
    }&nbsp;
    <button type="button" class="btn btn-danger" (click)='this.cancel()'>Cancel</button>
  </div>
</div>